import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CONSTANTS_DETAILS } from './shared/constant/constants';
import { AuthService } from './services/auth/auth.service';
import { RouterOutlet } from '@angular/router';
import {
  MatProgressSpinnerModule,
  ProgressSpinnerMode,
} from '@angular/material/progress-spinner';
import { SpinnerService } from './services/spinner/spinner.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatProgressSpinnerModule, AsyncPipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [AuthService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  public spinnerMode: ProgressSpinnerMode = 'indeterminate';
  constructor(
    private _translate: TranslateService,
    private _authService: AuthService,
    public _spinnerService: SpinnerService,
  ) {
    // Set the default language for the application
    this._translate.setDefaultLang(CONSTANTS_DETAILS.APP_DEAULT_LANGUAGE);
    this._translate.use(CONSTANTS_DETAILS.APP_DEAULT_LANGUAGE);
  }

  /**
   * Initializes the application by calling the authInitiator method from AuthService.
   *
   * @memberof AppComponent
   */
  ngOnInit() {
    this._authService.authInitiator();
    const navEntries = performance.getEntriesByType(
      'navigation',
    ) as PerformanceNavigationTiming[];
    if (navEntries.length && navEntries[0].type === 'reload') {
      localStorage.setItem('isAppRedirect', window.location.pathname);
    }
  }

  /**
   * Cleans up resources by completing the destroying observable in AuthService.
   *
   * @memberof AppComponent
   */
  ngOnDestroy() {
    this._authService._destroying$.next();
    this._authService._destroying$.complete();
  }
}
